import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, Button } from 'semantic-ui-react';

import Logo from './../Logo';
import closeIcon from './../../../assets/close.svg';
import hamburgerIcon from './../../../assets/hamburger.svg';
import * as styles from './NavbarMobile.less';

import arrowDown from '../../../assets/arrowdown.svg';

const arrowStyle = {
  left: '0px',
  top: '2px',
  position: 'relative',
  transform: 'rotate(275deg)',
  cursor: 'pointer',
};
const arrowCases = {
  left: '0px',
  top: '3px',
  position: 'relative',
  transform: 'rotate(-275deg)',
  cursor: 'pointer',
  width: '17px',
  marginRight: '10px',
};
const whiteButton = {
  color: '#000',
  background: '#fff',
  marginTop: '10px',
  fontWeight: '600',
};
const BlackButton = {
  color: '#fff',
  background: '#000',
  fontWeight: '500',
};

const NavbarMobile = ({
  children,
  onToggle,
  visible,
  onToggleUseCase,
  toggleUseCaseState,
}) => (
  <div
    style={{ background: visible ? '#fff' : '#FFDE00' }}
    className={styles.navbarWrapper}
  >
    {toggleUseCaseState ? (
      <div className={styles.logoWrapper}>
        <span className={styles.useCases} onClick={() => onToggleUseCase()}>
          <img src={arrowDown} style={arrowCases} />
          Use cases
        </span>
        {/* <img
          alt='hamburger'
          onClick={() => onToggle()}
          src={!visible ? hamburgerIcon : closeIcon}
          style={{
            width: !visible ? '2em' : '1.3em',
            top: !visible ? '1.875em' : '33px',
          }}
          className={styles.navbarIcon}
        /> */}
      </div>
    ) : (
      <div className={styles.logoWrapper}>
        <Link to={`/`}>
          <Logo size='large' />
        </Link>
        {/* <img
          alt='hamburger'
          onClick={() => onToggle()}
          src={!visible ? hamburgerIcon : closeIcon}
          style={{
            width: !visible ? '2em' : '1.3em',
            top: !visible ? '1.875em' : '33px',
          }}
          className={styles.navbarIcon}
        /> */}
      </div>
    )}
    {!visible ? (
      children
    ) : toggleUseCaseState ? (
      <Menu text vertical className={styles.navbarLinks}>
        <Menu.Item className={styles.clearOffset}>
          {/* <Link to={`/`} className={styles.linkItem}> */}
        </Menu.Item>
        <Menu.Item className={styles.clearOffset}>
          <Link to={`/`} className={styles.linkItem}>
            Landing Pages
          </Link>
        </Menu.Item>
        <Menu.Item className={styles.clearOffset}>
          <Link to={`/`} className={styles.linkItem}>
            value Propositions
          </Link>
        </Menu.Item>
        <Menu.Item className={styles.clearOffset}>
          <Link to={`/`} className={styles.linkItem}>
            Long-form sales pages
          </Link>
        </Menu.Item>
        <Menu.Item className={styles.clearOffset}>
          <Link to={`/`} className={styles.linkItem}>
            Newsletters
          </Link>
        </Menu.Item>
      </Menu>
    ) : (
      <Menu text vertical className={styles.navbarLinks}>
        <Menu.Item className={styles.clearOffset}>
          {/* <Link to={`/`} className={styles.linkItem}> */}
          <Link onClick={() => onToggleUseCase()} className={styles.linkItem}>
            Use cases
            <img src={arrowDown} style={arrowStyle} />
          </Link>
        </Menu.Item>
        <Menu.Item className={styles.clearOffset}>
          <Link to={`/pricing`} className={styles.linkItem}>
            Pricing
          </Link>
        </Menu.Item>
        <Menu.Item className={styles.clearOffset}>
          <Link to={`/blog`} className={styles.linkItem}>
            Blog
          </Link>
        </Menu.Item>
        <Menu.Item className={styles.clearOffset}>
          <Link to={`/about`} className={styles.linkItem}>
            About
          </Link>
        </Menu.Item>
      </Menu>
    )}
    {visible && (
      <div className={styles.buttonWrapper}>
        <div className={styles.buttonColumn}>
          <Link to={`/signup`}>
            <Button className={styles.buttonStyle} style={BlackButton}>
              Sign up
            </Button>
          </Link>
          <Link to={`/`}>
            <Button className={styles.buttonStyle} style={whiteButton}>
              Log in
            </Button>
          </Link>
        </div>
      </div>
    )}
  </div>
);

NavbarMobile.propTypes = {
  children: PropTypes.node,
  onToggle: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  toggleUseCaseState: PropTypes.bool,
  onToggleUseCase: PropTypes.func,
};

export default NavbarMobile;



// WEBPACK FOOTER //
// ./src/views/components/Navbar/NavbarMobile.js